import { render, staticRenderFns } from "./ViewFeedback.vue?vue&type=template&id=2974bd22&scoped=true"
import script from "./ViewFeedback.vue?vue&type=script&lang=js"
export * from "./ViewFeedback.vue?vue&type=script&lang=js"
import style0 from "./ViewFeedback.vue?vue&type=style&index=0&id=2974bd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974bd22",
  null
  
)

export default component.exports